import React from "react";

const Service = ({ description, category, jobTitle }) => {
  return (
    // bg-[#303241]
    <div className="bg-[#1a1c2c] border border-transparent hover:border-green-500 duration-300 p-5 rounded-md drop-shadow-lg">
      <h6 className="mb-10 font-roboto font-semibold text-green-500 text-xs">
        {category}
      </h6>
      <h3 className="font-bold text-2xl mb-8 text-white drop-shadow-xl shadow-black">
        {jobTitle}
      </h3>
      <p className="mb-5 text-white pb-20">{description}</p>
    </div>
  );
};

export default Service;
